<template>
  <div class="comp-user">
    <ul v-if="data && data.length">
      <li v-for="item in data" :key="item.id">
        <div class="left">
          <img @error="imgError" :src="item.Photo" :alt="item.Name" />
        </div>
        <div class="right">
          <div class="head">
            <strong>{{ item.Name }}</strong>
            <span>{{ item.Title }}</span>
          </div>
          <div class="body">
            <div class="desc">{{ item.Introduction }}</div>
            <router-link :to="item.link" :target="target">查看详细</router-link>
          </div>
        </div>
      </li>
    </ul>
    <div v-else class="g-nodata"></div>
  </div>
</template>

<script>
export default {
  name: "user-list",
  props: {
    data: {
      type: Array
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-user {
  li {
    display: flex;
    margin-bottom: 40px;
    .left {
      width: 104px;
      height: 104px;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 24px;
    }
    .right {
      flex: 1;
      .head {
        display: flex;
        align-items: center;
        span {
          color: #999;
          padding-left: 16px;
        }
        strong {
          font-size: 20px;
          font-weight: 500;
        }
        padding: 5px 0;
      }
      .desc {
        @include ellipsisc(2);
        line-height: 22px;
        color: #666;
        margin-bottom: 4px;
      }
      a {
        color: $primary-color;
        &:hover {
          color: $link-active-color;
        }
      }
    }
  }
}
</style>
